<template>
  <div class="col-md-12 order-container">
    <div
      class="col-md-12 float-left"
      v-for="ped in this.pedidos"
      :key="ped.idPedido"
    >
      <card>
        <div class="row">
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.reference") }}</b>:
            {{ ped.idPedido }}
            <br />
            <b>{{ $t("app.modules.orders.headers.order_number") }}</b>:
            {{ ped.numPedidoSAP }}
            <br />
            {{ ped.estadoPEdido }}
          </div>
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.created_date") }}</b>:
            {{ ped.fechaCreacionPedido }}
            <br />
            <b>{{ $t("app.modules.orders.headers.auth_date") }}</b>:
            {{ ped.fechaConfirmacionPedido != "1900-01-01 00:00:00" ? ped.fechaConfirmacionPedido: "" }}
          </div>
          <!--
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.salesman") }}</b>:
            <br />
            {{ ped.vendedor }}
          </div>
          -->
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.customer_service") }}</b>:
            <br />
            {{ ped.servicioCliente }}
          </div>
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.purchase_order") }}</b>:
            <br />
            {{ ped.ordenCompraCliente }}
          </div>
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.subtotal") }}</b>:
            {{ (ped.total != null ? ped.total.toFixed(4) : 0) | currencyFormat}}
            <br />
            <b>{{ $t("app.modules.orders.headers.money") }}</b>:
            {{ ped.moneda }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-9">&nbsp;</div>
          <div class="col-md-3">
            <verify-permission controller="Pedidos" action="getPedidoDetalleWeb">
              <n-button
                type="primary"
                class="btn btn-sm"
                @click.native="showDetail(ped.idPedido)"
              >
                {{ $t("app.modules.orders.web.view_detail") }}
              </n-button>
            </verify-permission>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data() {
    return {
      pedidos: [
        {
          idPedido: 1,
          fechaCreacionPedido: "1900-01-01",
          fechaConfirmacionPedido: "1900-01-01",
          estadoPedido: "",
          ordenCompraCliente: "",
          razonSocial: "",
          numPedidoSAP: "ORDR55669988",
          nombre: "",
          idUsuarioServicioCliente: 0,
          nombreUsuarioServicioCliente: "",
          idClienteSAP: 0,
          idEstadoPedido: 0,
          fechaEstimadaEntrega: "1900-01-01",
        },
        {
          idPedido: 2,
          fechaCreacionPedido: "1900-01-01",
          fechaConfirmacionPedido: "1900-01-01",
          estadoPedido: "",
          ordenCompraCliente: "",
          razonSocial: "",
          numPedidoSAP: "ORDR55666677",
          nombre: "",
          idUsuarioServicioCliente: 0,
          nombreUsuarioServicioCliente: "",
          idClienteSAP: 0,
          idEstadoPedido: 0,
          fechaEstimadaEntrega: "1900-01-01",
        },
        {
          idPedido: 3,
          fechaCreacionPedido: "1900-01-01",
          fechaConfirmacionPedido: "1900-01-01",
          estadoPedido: "",
          ordenCompraCliente: "",
          razonSocial: "",
          numPedidoSAP: "ORDR44339988",
          nombre: "",
          idUsuarioServicioCliente: 0,
          nombreUsuarioServicioCliente: "",
          idClienteSAP: 0,
          idEstadoPedido: 0,
          fechaEstimadaEntrega: "1900-01-01",
        },
      ],
    };
  },
  created() {},
  async mounted() {
    await this.getOrders();
  },
  methods: {
    async getOrders() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang,
        Usuario: this.$store.state.user.idClienteSAP,
        Estado: 0,
      };

      await this.$http.post(route("Pedidos/ListaPedidosWeb"), params).then(
        (response) => {
          if (response.body.code === 200) {
            console.log("Pedidos:")
            console.log(response.body.pedidos);
            this.pedidos = response.body.pedidos
              .filter(
                (p) =>
                  p.idEstadoPedido == 1 ||
                  p.idEstadoPedido == 2 ||
                  p.idEstadoPedido == 4
              )
              .slice(0, 3);
          } else {
            console.log(response.body);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        (error) => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
    },
    showDetail(id) {
      console.log(id);
      this.$router.push({
        name: "Detalle pedido web",
        params: { idPedido: id },
      });
    }
  },
  filters: {
    currencyFormat(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(",", ".");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return null;
    }
  }
};
</script>

<style scoped>
.order-container {
  margin-top: 20px;
}

.order-status {
  color: red;
}

.order-head {
  background-color: white;
}

.order-row {
  cursor: pointer;
}
</style>
